import React from 'react';
import * as Sentry from '@sentry/react';
import ErrorPage from '@shared/pages/ErrorPage';

interface GlobalErrorBoundaryProps {
  children: React.ReactNode;
}

const getOrderIdFromPath = (): string | undefined =>
  window.location.pathname.match(/\/order\/([^/]+)/)?.[1];

export const GlobalErrorBoundary: React.FC<GlobalErrorBoundaryProps> = ({
  children,
}) => {
  return (
    <Sentry.ErrorBoundary
      fallback={({ error }) => {
        console.error('Global error:', error);
        return <ErrorPage statusCode='UNEXPECTED_ERROR' />;
      }}
      beforeCapture={(scope, error) => {
        const orderId = getOrderIdFromPath();
        const reason = error instanceof Error ? error.message : String(error);

        scope.setTag('captureLocation', 'global_error_boundary');
        scope.setTag('errorReason', reason);
        if (orderId) {
          scope.setTag('orderId', orderId);
        }
        scope.setContext('errorBoundary', {
          orderId,
          reason,
          url: window.location.href,
        });
      }}
      showDialog={false}
    >
      {children}
    </Sentry.ErrorBoundary>
  );
};
